export const PROFILE_TYPE_CATALOG = [
    {
        type: "country",
        label: "Countries / Regulatory",
        nameColumnLabel: "Country",
        searchEndpoint: "SearchCountries",
        statsEndpoint: "GetRegulatoryStats",
        infoColumns: [
            { key: "Region", label: "Region" },
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "News", label: "News" },
            { key: "Regulations", label: "Regulations" },
            { key: "Guidance", label: "Guidance" },
            { key: "Standards", label: "Standards" },
            { key: "Consultations", label: "Consultations" },
            { key: "Events", label: "Events" },
        ],
    },
    {
        type: "standard-watch",
        label: "Standards",
        nameColumnLabel: "Standard",
        searchEndpoint: "SearchStandards",
        statsEndpoint: "GetStandardStats",
        infoColumns: [
            { key: "Title", label: "Title" },
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "Updates", label: "Updates" },
            { key: "RegionalAdoptions", label: "Regional Adoptions" },
            { key: "AuthoritiesNews", label: "Authorities News" },
            { key: "InTheNews", label: "In the News" },
        ],
    },
    {
        type: "competitor",
        label: "Competitors / Manufacturers",
        nameColumnLabel: "Manufacturer",
        searchEndpoint: "SearchManufacturer",
        statsEndpoint: "GetCompetitorStats",
        infoColumns: [
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "FSCAS", label: "MedTech FSCAs" },
            { key: "Approvals", label: "MedTech Approvals" },
            { key: "PressReleases", label: "Press Releases" },
            { key: "InTheNews", label: "In the News" },
            { key: "AdverseEvents", label: "MedTech Adverse Events" },
            { key: "ClinicalArticles", label: "Clinical Articles" },
            { key: "ClinicalTrials", label: "Clinical Trials" },
            { key: "Inspections", label: "Inspections" },
            { key: "WarningLetters", label: "Warning Letters" },
            { key: "DrugApprovals", label: "Pharma Approvals" },
            { key: "DrugFSCAS", label: "Pharma FSCAs" },
            { key: "DrugAdverseEvents", label: "Pharma Adverse Events" },
        ],
    },
    {
        type: "fdaestablishments",
        label: "FDA Establishments",
        nameColumnLabel: "Organization",
        searchEndpoint: "SearchEstablishments",
        statsEndpoint: "GetFDAEstablishmentStats",
        infoColumns: [
            { key: "FEI", label: "FEI" },
            { key: "RiskScore", label: "Risk Score" },
            { key: "Tags", label: "Tags" },
        ],
        columnOrder: ["FEI", "Name", "RiskScore", "Tags", "stats", "Action"],
        statsFields: [
            { key: "FSCAS", label: "FSCAs" },
            { key: "Inspections", label: "Inspections" },
            { key: "InspectionDocuments", label: "FDA 483s" },
            { key: "WarningLetters", label: "Warning Letters" },
            { key: "ImportRefusals", label: "Import Refusals" },
            { key: "ImportAlerts", label: "Import Alerts" },
            { key: "ComplianceActions", label: "Compliance Actions" },
        ],
    },
    {
        type: "product",
        label: "Products",
        nameColumnLabel: "Product",
        searchEndpoint: "SearchProduct",
        statsEndpoint: "GetProductStats",
        infoColumns: [
            { key: "Manufacturer", label: "Manufacturer" },
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "FSCAS", label: "FSCAs" },
            { key: "Approvals", label: "Approvals" },
            { key: "SafetyAlerts", label: "Safety Alerts" },
            { key: "InTheNews", label: "In the News" },
            { key: "AdverseEvents", label: "Adverse Events" },
            { key: "ClinicalArticles", label: "Clinical Articles" },
            { key: "ClinicalTrials", label: "Clinical Trials" },
        ],
    },
    {
        type: "drug",
        label: "Drugs",
        nameColumnLabel: "Product",
        searchEndpoint: "SearchDrugs",
        statsEndpoint: "GetDrugStats",
        infoColumns: [
            { key: "Manufacturer", label: "Manufacturer" },
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "FSCAS", label: "FSCAs" },
            { key: "Approvals", label: "Approvals" },
            { key: "SafetyAlerts", label: "Safety Alerts" },
            { key: "InTheNews", label: "In the News" },
            { key: "AdverseEvents", label: "Adverse Events" },
            { key: "ClinicalArticles", label: "Clinical Articles" },
            { key: "ClinicalTrials", label: "Clinical Trials" },
        ],
    },
    {
        type: "substance",
        label: "Substances",
        nameColumnLabel: "Product",
        searchEndpoint: "SearchSubstances",
        statsEndpoint: "GetDrugSubstanceStats",
        infoColumns: [
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "FSCAS", label: "FSCAs" },
            { key: "Approvals", label: "Approvals" },
            { key: "SafetyAlerts", label: "Safety Alerts" },
            { key: "InTheNews", label: "In the News" },
            { key: "AdverseEvents", label: "Adverse Events" },
            { key: "ClinicalTrials", label: "Clinical Trials" },
        ],
    },
    {
        type: "people",
        label: "People",
        nameColumnLabel: "Person",
        searchEndpoint: "SearchPeople",
        statsEndpoint: "GetPeopleStats",
        infoColumns: [
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "ClinicalArticles", label: "Clinical Articles" },
            { key: "ClinicalTrials", label: "Clinical Trials" },
            { key: "Approvals", label: "Approvals" },
            { key: "News", label: "News" },
            { key: "PRRCs", label: "PRRCs" },
        ],
    },
    {
        type: "industryorg",
        label: "Industry Organizations",
        nameColumnLabel: "Organization",
        searchEndpoint: "SearchIndustryOrganizations",
        statsEndpoint: "GetInudstryOrganizationStats",
        infoColumns: [
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "News", label: "News" },
        ],
    },
    {
        type: "healthcareprovider",
        label: "Healthcare Providers",
        nameColumnLabel: "Hospital",
        searchEndpoint: "SearchHealthcareProvider",
        statsEndpoint: "GetClinicalStats",
        infoColumns: [
            { key: "Location", label: "Location" },
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [
            { key: "News", label: "News" },
            { key: "ClinicalTrials", label: "Clinical Trials" },
        ],
    },
    {
        type: "mobileapp",
        label: "Mobile Apps",
        nameColumnLabel: "Product",
        searchEndpoint: "SearchMobileApps",
        // Legacy Mobile Apps list has no statistics columns (commented out in MobileAppsIntelligence.cshtml)
        infoColumns: [
            { key: "Manufacturer", label: "Manufacturer" },
            { key: "Tags", label: "Tags" },
        ],
        statsFields: [],
    },
];

/** Maps Profiles URL alias (`/profiles/{alias}/...`) → watchlist profile type */
export const PROFILE_URL_TO_WATCHLIST_TYPE = {
    manufacturers: "competitor",
    products: "product",
    medicines: "drug",
    substances: "substance",
    mobileapps: "mobileapp",
    countries: "country",
    technicalstandards: "standard-watch",
    hospitals: "healthcareprovider",
    people: "people",
    industryorganizations: "industryorg",
    establishments: "fdaestablishments",
};

export const getWatchlistTypeFromProfileAlias = (profileAlias) => {
    if (!profileAlias) return null;
    return PROFILE_URL_TO_WATCHLIST_TYPE[profileAlias.toLowerCase()] || null;
};

export const getProfileTypeLabel = (type) => {
    const found = PROFILE_TYPE_CATALOG.find(t => t.type === type);
    return found ? found.label : type;
};

export const getProfileTypeConfig = (type) => {
    return PROFILE_TYPE_CATALOG.find(t => t.type === type) || null;
};

export const getTableColumns = (config) => {
    if (!config) return [];

    const hasStats = (config.statsFields || []).length > 0;

    if (config.columnOrder && config.columnOrder.length) {
        return config.columnOrder.map((key) => {
            if (key === "Name")
                return { key: "Name", label: config.nameColumnLabel || "Name", kind: "name" };
            if (key === "stats")
                return hasStats ? { key: "stats", label: "Statistics", kind: "stats" } : null;
            if (key === "Action")
                return { key: "Action", label: "Action", kind: "action" };
            if (key === "Tags")
                return { key: "Tags", label: "Tags", kind: "tags" };
            const info = (config.infoColumns || []).find(c => c.key === key);
            return { key, label: info?.label || key, kind: "extra" };
        }).filter(Boolean);
    }

    const columns = [
        { key: "Name", label: config.nameColumnLabel || "Name", kind: "name" },
    ];

    (config.infoColumns || []).forEach((col) => {
        if (col.key === "Tags")
            columns.push({ key: "Tags", label: col.label, kind: "tags" });
        else
            columns.push({ key: col.key, label: col.label, kind: "extra" });
    });

    if (hasStats)
        columns.push({ key: "stats", label: "Statistics", kind: "stats" });
    columns.push({ key: "Action", label: "Action", kind: "action" });
    return columns;
};

/** Statistics columns a user can show or hide. Name, tags, and other fields stay visible. */
export const getConfigurableColumns = (config) => {
    return (config?.statsFields || []).map((field) => ({
        key: `stats:${field.key}`,
        label: field.label,
        kind: "statsField",
        statsKey: field.key,
    }));
};
